"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
const react_1 = require("react");
function useDebounce(value, delay, options = {}) {
    var _a;
    const [debouncedValue, setDebouncedValue] = react_1.useState((_a = options.defaultValue) !== null && _a !== void 0 ? _a : value);
    react_1.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}
exports.useDebounce = useDebounce;
//# sourceMappingURL=useDebounce.js.map